import React from 'react'
import { SmallTickIcon, Pane, Text } from 'evergreen-ui'
import { MESSAGES } from '../../../config/admissionRound'

const StatusRegister_4 = ({ DataRegister }) => {
  return (
    <>
      <Pane
        color="#ffffff"
        backgroundColor="#164e00"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
        fontWeight={700}
        marginBottom={0}
        display="flex" alignItems="center" justifyContent="center"
      >
        <Text color="#ffffff" fontWeight={700}>
          <SmallTickIcon /> ผู้มีสิทธิ์เข้าศึกษา
        </Text>
      </Pane>
      <Pane
        color="#1b4332"
        backgroundColor="#d8f3dc"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={16}
        fontFamily=""
        fontWeight={700}
        marginBottom={0}
        marginTop={8}
      >
        &nbsp;
        <Text color="#1b4332" fontWeight={700}>
          ผู้มีสิทธิ์เข้าศึกษา {DataRegister[0].QUOTA_NAME}{" "}
          {DataRegister[0].ROB_NAME !== null ? DataRegister[0].ROB_NAME : ""}
        </Text>

        <br />
        <Text color="#1b4332" fontWeight={700}>
          {DataRegister[0].Major1_faculty_name}{" "}
          {" หลักสูตร " + DataRegister[0].Major1_LEVEL_OPEN_NAME}
        </Text>
        <br />
        <Text color="#1b4332" fontWeight={700}>
          {DataRegister[0].Major1_MAJOR_ID + " : " + DataRegister[0].Major1_MAJOR_NAME}
        </Text>
      </Pane>
      <Pane
        hidden={DataRegister[0].REGISTER_ORDER_NUMBER === null ||
          DataRegister[0].REGISTER_ORDER?.includes(DataRegister[0].Major1_MAJOR_ID)}
        color="#8a2846"
        backgroundColor="#ffe5ec"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={14}
        fontFamily=""
        margin={0}
        marginTop={8}
        fontWeight={700}
      >
        ผ่านการคัดเลือกเป็น {DataRegister[0].REGISTER_ORDER}
      </Pane>
      <Pane
        hidden={DataRegister[0].REGISTER_ORDER_NUMBER1 === null ||
          DataRegister[0].REGISTER_ORDER1?.includes(DataRegister[0].Major1_MAJOR_ID)}
        color="#8a2846"
        backgroundColor="#ffe5ec"
        height="100%"
        paddingY={4}
        paddingX={5}
        fontSize={14}
        fontFamily=""
        margin={0}
        marginTop={8}
        fontWeight={700}
      >
        ผ่านการคัดเลือกเป็น {DataRegister[0].REGISTER_ORDER1}
      </Pane >

      {
        (DataRegister[0].Major1_MAJOR_ID === "xxxx") ? (
          <>
            <Pane
              backgroundColor={"#fffae5"}
              color="#c36f09"
              paddingY={4}
              paddingX={5}
              fontSize={14}
              fontFamily=""
              margin={0}
              marginTop={8}
              fontWeight={700}
            >
              {MESSAGES.admitNurseBodyExam}
            </Pane>
            <Text color="red">หมายเหตุ* </Text>
            <Text color="red">{MESSAGES.admitNurseAnnounce}</Text>
          </>
        ) : (
          <Pane display="flex" flexDirection="column" marginTop={8}>
            <Text color="red">หมายเหตุ*</Text>
            {
              DataRegister[0].Major1_MAJOR_ID === "8301" || DataRegister[0].Major1_MAJOR_ID === "8203" || DataRegister[0].Major1_MAJOR_ID === "8201" || DataRegister[0].Major1_MAJOR_ID === "8205" || DataRegister[0].Major1_MAJOR_ID === "8401"
                ? (
                  <>
                    <Text fontSize={"12px"}>
                      {MESSAGES.admitPayWindowMay11_14}
                    </Text>
                  </>
                ) : (
                  <>
                    <Text fontSize={"12px"}>
                      {MESSAGES.admitPayWindowMay11_15}
                    </Text>
                  </>
                )
            }
          </Pane>
        )
      }
    </>
  )
}

export default StatusRegister_4
